import React, { useState } from "react";
import CardHeader from "../../../components/atoms/cardHeader";
import { Col, Row } from "antd";
import moment from "moment";
import media from "../../../media";
import TextArea from "antd/es/input/TextArea";

export const Overview = ({ data }) => {
  const [remarks, setRemarks] = useState();
  return (
    <>
      {/*General Information Start*/}
      <div className="card card-custom mb-5">
        <CardHeader name={"General Information"} />
        <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-2">
          <div className="table-responsive">
            <table className="table table-borderless">
              <tbody>
                <tr className="greyBackground">
                  <td className="" style={{ width: "20%" }}>
                    Return ID
                  </td>
                  <td className="" style={{ width: "30%" }}>
                    <span className="text-muted">
                      {data?.generalInformation?.returnId || "--"}
                    </span>
                  </td>
                  <td className="" style={{ width: "20%" }}>
                    Customer Name
                  </td>
                  <td className="" style={{ width: "30%" }}>
                    <span className="text-muted">
                      {data?.generalInformation?.customerName?.en || "--"}
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="">Return Request Date</td>
                  <td className="">
                    <span className="text-muted">
                      {moment
                        .utc(data?.generalInformation?.returnRequestDate)
                        .local()
                        .format("DD/MM/YYYY hh:mm A")}
                    </span>
                  </td>
                  <td className="">Email</td>
                  <td className="">
                    <span className="text-muted">
                      {data?.generalInformation?.customerEmail || "--"}
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="">Order Date</td>
                  <td className="">
                    <span className="text-muted">
                      {moment
                        .utc(data?.generalInformation?.orderedDate)
                        .local()
                        .format("DD/MM/YYYY hh:mm A")}
                    </span>
                  </td>
                  <td className="">Phone</td>
                  <td className="">
                    <span className="text-muted">
                      +91-{" "}
                      {data?.generalInformation?.customerPhoneNumber || "--"}
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="">Delivery Date</td>
                  <td className="">
                    <span className="text-muted">
                      {moment
                        .utc(data?.generalInformation?.deliveredDate)
                        .local()
                        .format("DD/MM/YYYY hh:mm A")}
                    </span>
                  </td>
                  <td className=""> </td>
                  <td className="">
                    <span className="text-muted"> </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/*General Information End*/}

      {/*Original Order Shipment Mode Start*/}
      <div className="card card-custom mb-5">
        <CardHeader name={"Original Order Shipment Mode"} />
        <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-2">
          <div className="table-responsive">
            <table className="table table-borderless">
              <tbody>
                <tr className="greyBackground">
                  <td className="" style={{ width: "20%" }}>
                    Shipment Mode
                  </td>
                  <td className="" style={{ width: "80%" }}>
                    <span className="text-muted">
                      {data?.originalShipmentMode?.shipmentMode || "--"}
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="" style={{ width: "20%" }}>
                    Tracking ID
                  </td>
                  <td className="" style={{ width: "80%" }}>
                    <span className="text-muted">
                      {data?.originalShipmentMode?.trackingID || "--"}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/*Original Order Shipment Mode End*/}

      {/*Return Products Start*/}
      {
        <div className="card card-custom mb-5">
          <CardHeader name={"Return Products Request"} />
          <div className="border-1 border-dark border-top-0 card-body p-0">
            <div className="table-responsive">
              <table className="table table-bordered m-0 border radius-remove text-center">
                <thead className="">
                  <tr>
                    <th className="align-middle text-left">ITEMS</th>
                    <th className="align-middle">DELIVERY OPTION</th>
                    <th className="align-middle">MRP</th>
                    <th className="align-middle">SELLING PRICE</th>
                    <th className="align-middle">QUANTITY</th>
                    <th className="align-middle">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="align-middle">
                      <div className="d-flex align-items-center">
                        <div className="symbol symbol-50 flex-shrink-0 mr-4">
                          <img
                            src={
                              data?.returnProductRequest?.imageUrl
                                ? data?.returnProductRequest?.imageUrl
                                : media.Default
                            }
                            className="w-100"
                            alt=""
                          />
                        </div>
                        <div className="d-flex flex-column font-weight-bold text-left">
                          <span className="">
                            {data?.returnProductRequest?.proudctName?.en} -{" "}
                            {data?.returnProductRequest?.variant || "--"}
                          </span>
                          <span className="text-muted">
                            SKU: {data?.returnProductRequest?.sku || "--"}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="align-middle">
                      {data?.returnProductRequest?.deliveryOption ===
                      "PICK_UP_FROM_VENDOR"
                        ? "PICK UP"
                        : "HOME DELIVERY" || "--"}
                    </td>
                    <td className="align-middle">
                      Rs. {data?.returnProductRequest?.mrp || "--"}
                    </td>
                    <td className="align-middle">
                      Rs. {data?.returnProductRequest?.sellingPrice || "--"}
                    </td>
                    <td className="align-middle">
                      {data?.returnProductRequest?.quantity || "--"}
                    </td>
                    <td className="align-middle">
                      Rs. {data?.returnProductRequest?.itemTotal || "--"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive">
              <table className="table table-borderless border-top-0 m-0 border radius-remove text-center text-capitalize">
                <thead className="">
                  <tr>
                    <th className="" style={{ width: "25%" }}>
                      Requested At
                    </th>
                    <th className="text-left">Return Reason</th>
                    {/* <th className="">Attachment</th> */}
                    <th className="text-left" colSpan={3}>
                      Reason for refund:{" "}
                      {data?.refundStatus !== "REFUND_PENDING" &&
                        data?.refundReason}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="">
                      {moment(
                        data?.generalInformation?.returnRequestDate
                      ).format("DD/MM/YYYY hh:mm A")}
                    </td>
                    <td className="text-left">
                      {data?.returnProductRequest?.returnReason || "--"}
                    </td>

                    {data?.refundStatus === "REFUND_PENDING" && (
                      <td className="" colSpan={2}>
                        <p className="text-left">
                          Refund Requested Date:{" "}
                          {moment(data?.refundInitiatedDate).format(
                            "DD/MM/YYYY"
                          )}
                        </p>
                        <TextArea
                          rows={4}
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                        />
                      </td>
                    )}
                    {data?.refundStatus === "REFUND_INITIATED" && (
                      <td className="text-left">
                        Refund Approved Date:{" "}
                        {moment(data?.refundApproveDate).format("DD/MM/YYYY")}
                      </td>
                    )}
                    {data?.refundStatus === "REFUND_CANCELLED" && (
                      <td className="text-left">
                        Refund Cancelled Date:{" "}
                        {moment(data?.refundCancelledDate).format("DD/MM/YYYY")}
                      </td>
                    )}
                    {data?.refundStatus === "REFUND_COMPLETED" && (
                      <td className="text-left">
                        Refund Completed Date:{" "}
                        {moment(data?.refundCompletedDate).format("DD/MM/YYYY")}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="" colSpan={3}>
                      {" "}
                    </td>
                    {data?.refundStatus === "REFUND_PENDING" && (
                      <>
                        <td className="">
                          <button
                            type="submit"
                            className="btn btn-success"
                            onClick={(e) => {
                              e.preventDefault();
                              //   approveReturn(false);
                            }}
                          >
                            Decline Refund
                          </button>
                        </td>
                        <td className="">
                          <button
                            type="submit"
                            className="btn btn-success"
                            onClick={(e) => {
                              e.preventDefault();
                              //   approveReturn(true);
                            }}
                          >
                            Approve Refund
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
      {/*Return Products End*/}

      {/*Shipping Start*/}
      <Row gutter={[12, 12]}>
        <Col className="gutter-row" xs={24} lg={12}>
          <div className="card card-custom h-100">
            <div
              className="card-header py-3 bg-gray-700"
              style={{ minHeight: "0" }}
            >
              <div className="card-title align-items-start flex-column justify-content-center">
                <h3 className="card-label font-weight-bolder text-white">
                  Shipping Address
                </h3>
              </div>
            </div>
            <div className="card-body p-4 border-1 border-light-dark border border-top-0">
              <div className="font-weight-bold mb-3">
                {data?.shippingAddress?.fullName}
              </div>
              <div className="text-muted mb-3">
                {data?.shippingAddress?.address}
                <br></br>
                {data?.shippingAddress?.streetDetail},{" "}
                {data?.shippingAddress?.district?.name},
                {data?.shippingAddress?.state?.name},{" "}
                {data?.shippingAddress?.pinCode}
              </div>
            </div>
          </div>
        </Col>
        <Col className="gutter-row" xs={24} lg={12}>
          <div className="card card-custom h-100">
            <div
              className="card-header py-3 bg-gray-700"
              style={{ minHeight: "0" }}
            >
              <div className="card-title align-items-start flex-column justify-content-center">
                <h3 className="card-label font-weight-bolder text-white">
                  Store Address
                </h3>
              </div>
            </div>
            <div className="card-body p-4 border-1 border-light-dark border border-top-0">
              <div className="font-weight-bold mb-3">
                {data?.storeAddress?.fullName}
              </div>
              <div className="text-muted mb-3">
                {data?.storeAddress?.address}
                <br></br>
                {data?.storeAddress?.state} - {data?.storeAddress?.pinCode}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/*Shipping End*/}
    </>
  );
};
